import { HEADER_CLIENT_RELOAD } from "@faire/web--source/common/consts/HEADER_CLIENT_RELOAD";
import { forceReload } from "@faire/web--source/common/forceReload";
import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import postUserEvent from "@faire/web-api--source/api/event/post";
import { IUserEvent } from "@faire/web-api--source/indigofair/data/IUserEvent";
var FORCE_VALUE = "force";
export var clientReloadInterceptor = function(_request, response) {
    var _response_headers, _response_headers1;
    var xIfClientReload = ((_response_headers = response.headers) === null || _response_headers === void 0 ? void 0 : _response_headers[HEADER_CLIENT_RELOAD]) || ((_response_headers1 = response.headers) === null || _response_headers1 === void 0 ? void 0 : _response_headers1[HEADER_CLIENT_RELOAD.toLowerCase()]);
    if (xIfClientReload === FORCE_VALUE) {
        postUserEvent("www", IUserEvent.build({
            path: "/force-reload/from-".concat(getGlobalProperty("releaseVersion"), "/to-").concat(xIfClientReload)
        }));
        forceReload();
    }
    return response;
};
